import type { Middleware } from '@reduxjs/toolkit';
import { signInUser, signOutUser, updateAccessToken } from 'redux/slices/user.slice';
import { User } from 'redux/types/user';
import { clearSession, writeSession } from 'services/session/sessionStore';

const ADOPTED_META = 'fromSharedSession';

export const adopted = <A extends { type: string }>(action: A): A & { meta: { [ADOPTED_META]: true } } => ({
  ...action,
  meta: { [ADOPTED_META]: true },
});

const isAdopted = (action: unknown): boolean =>
  typeof action === 'object' &&
  action !== null &&
  (action as { meta?: Record<string, unknown> }).meta?.[ADOPTED_META] === true;

const sessionMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  if (isAdopted(action)) return result;

  if (signInUser.match(action) || updateAccessToken.match(action)) {
    writeSession((api.getState() as { user: User }).user);
  } else if (signOutUser.match(action)) {
    clearSession();
  }
  return result;
};

export default sessionMiddleware;
